import { Button, Modal, Typography } from 'antd';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import rfsTheme from '../../../theme';
import routes, { routesWithPathParameter } from '../../App/routes';

const { Text } = Typography;

/**
 * A button for shift related warnings that can direct user to another team.
 */
const ShiftWarningTeamButton = ({
  team,
  light,
}: {
  readonly team?: {
    readonly id?: string;
    readonly name?: string;
  };
  readonly light?: boolean;
}) => {
  const navigate = useNavigate();

  const [showNavigateModal, setShowNavigationModal] = useState(false);

  const goToTeam = (teamId?: string) => () => {
    if (teamId !== undefined) {
      navigate(routesWithPathParameter(routes.teamRoster, 'teamId', teamId));

      toggleNavigationModal();
    }
  };

  const toggleNavigationModal = () => {
    setShowNavigationModal(!showNavigateModal);
  };

  return (
    <>
      <Button
        type="link"
        style={{
          padding: 0,
          whiteSpace: 'normal',
          height: 'auto',
          textAlign: 'left',
          color: light === true ? 'white' : rfsTheme.darkRfsRed,
        }}
        onClick={toggleNavigationModal}
      >
        @ team&nbsp;
        <Text
          style={{
            color: light === true ? 'white' : rfsTheme.darkRfsRed,
            fontWeight: 'bold',
            textDecoration: 'underline',
          }}
        >
          {team?.name ?? ''}
        </Text>
      </Button>

      <Modal
        destroyOnClose={true}
        open={showNavigateModal}
        title={`Navigate to team ${team?.name ?? ''}?`}
        onCancel={toggleNavigationModal}
        onOk={goToTeam(team?.id)}
        okText={`Go to ${team?.name ?? ''}`}
      >
        <p>You are about to navigate to team {team?.name ?? ''}.</p>
      </Modal>
    </>
  );
};

export default ShiftWarningTeamButton;
